module.exports = __webpack_public_path__ + "img/congo.e6f61257.svg";